import { Type } from '@angular/core';

import { CmsFaqBlock } from '@shared/cms/sections/faq-block/faq-block';
import { CmsWidgetListBlock } from '@shared/cms/sections/widget-list-block/widget-list-block';
import { CmsSuccessStories } from '@shared/cms/sections/success-stories/success-stories';
import { CmsStaticBlock } from '@shared/cms/sections/static-block/static-block';
import { CmsSliderBlock } from '@shared/cms/sections/slider-block/slider-block';
import { CmsCardsBlock } from '@shared/cms/sections/cards-block/cards-block';
import { CmsActionCard } from '@shared/cms/sections/action-card/action-card';
import { CmsStaticBlockWithTags } from '@shared/cms/sections/static-block-with-tags/static-block-with-tags';
import { CmsStaticBlockWithTagsWizard } from '@shared/cms/sections/static-block-with-tags-wizard/static-block-with-tags-wizard';
import { CmsContentGroup } from '@shared/cms/sections/content-group/content-group';
import { CmsCardsContentGroup } from '@shared/cms/sections/cards-content-group/cards-content-group';
import { CmsTabsBlock } from '@shared/cms/sections/tabs-block/tabs-block';
import { CmsHowItWorksBlock } from '@shared/cms/sections/how-it-works-block/how-it-works-block';
import { CmsUnknownSection } from '@shared/cms/sections/unknown-section/unknown-section';

/**
 * Maps a CMS section `__typename` to the component that renders it — the modern, standalone
 * counterpart of the legacy `LANDING_PAGE_COMPONENTS` map. The dispatcher ({@link CmsSections})
 * looks components up here; registering a new section type is a single entry. Every rendered
 * component receives the section object via a `section` input.
 */
export const CMS_SECTION_COMPONENTS: Readonly<Record<string, Type<unknown>>> = {
    ComponentSectionFaqBlock: CmsFaqBlock,
    ComponentSectionWidgetListBlock: CmsWidgetListBlock,
    ComponentSectionSuccessStories: CmsSuccessStories,
    ComponentSectionStaticBlock: CmsStaticBlock,
    ComponentSectionSliderBlock: CmsSliderBlock,
    ComponentSectionCardsBlock: CmsCardsBlock,
    ComponentSectionActionCard: CmsActionCard,
    ComponentSectionStaticBlockWithTags: CmsStaticBlockWithTags,
    ComponentSectionStaticBlockWithTagsWizard: CmsStaticBlockWithTagsWizard,
    ComponentSectionContentGroup: CmsContentGroup,
    ComponentSectionCardsContentGroup: CmsCardsContentGroup,
    ComponentSectionTabsBlock: CmsTabsBlock,
    ComponentSectionHowItWorksBlock: CmsHowItWorksBlock,
};

/** Fallback for any `__typename` absent from {@link CMS_SECTION_COMPONENTS} (incl. the `Error` member). */
export const CMS_UNKNOWN_SECTION_COMPONENT: Type<unknown> = CmsUnknownSection;

/** Resolves the component for a section `__typename`, falling back to the unknown placeholder. */
export function cmsComponentFor(typename: string): Type<unknown> {
    return CMS_SECTION_COMPONENTS[typename] ?? CMS_UNKNOWN_SECTION_COMPONENT;
}
